


















import { Component, Vue } from 'vue-property-decorator';
import { getConfigLink } from '@/lib/build';

@Component
export default class EquipmentsConfigureKit extends Vue {
  pending = false;
  error: Error | null = null;

  async openEquipmentsConfigureKitDialog() {
    this.$pdc.bus!.emit('equipments:configure-kit-dialog:open');
  }

  get stations() {
    return this.$pdc.entities!.stations.storedEntity;
  }
}
